import React from "react";
import { Form, Button } from "react-bootstrap";

const BooleanView = (props) => {
  const isFirst =
  (props.selected && props.selected.toLowerCase()) === (props.firstButton && props.firstButton.toLowerCase());
  const firstVariant = isFirst ? "primary" : "outline-secondary";

  const secondVariant = isFirst ? "outline-secondary" : "primary";

  return (
    <>
      <Form.Group>
        <Form.Label>
          {props.title} {props.tutorial}
        </Form.Label>
        <div>
          <Button
            variant={firstVariant}
            onClick={() => props.onSelect(props.firstButton)}
            className="mr-2"
          >
            {props.firstButton.toUpperCase()}
          </Button>
          <Button
            variant={secondVariant}
            onClick={() => props.onSelect(props.secondButton)}
          >
            {props.secondButton.toUpperCase()}
          </Button>
        </div>
      </Form.Group>
    </>
  );
};

export default BooleanView;
